export const BUTTONBORDERRADIUS = 6;
export const BUTTONBORDERWIDTH = 1;
